import { createContext } from "react";

const ExpandableMenuContext = createContext();

export default ExpandableMenuContext;